import { gql } from "@urql/core";

export const GET_MENU_DATA = gql`
  query siteMenuData {
    CMS {
      siteMenu {
        id
        MenMenu {
          id
          Title
          items {
            id
            Title
            Subtitle
            Description
            CategoryId
            RelativePosition
            Image {
              id
              url
            }
            Visible
            ButtonTitle
            menu_children {
              id
              Title
              Subtitle
              Description
              CategoryId
              ShowUnderParent
              RelativePosition
              Image {
                id
                url
              }
              ButtonTitle
              Visible
            }
          }
        }
        WomenMenu {
          id
          Title
          items {
            id
            Title
            Subtitle
            Description
            CategoryId
            RelativePosition
            Image {
              id
              url
            }
            Visible
            ButtonTitle
            menu_children {
              id
              Title
              Subtitle
              Description
              CategoryId
              ShowUnderParent
              RelativePosition
              Image {
                id
                url
              }
              ButtonTitle
              Visible
            }
          }
        }
      }
    }
  }
`;
